import { LogClick } from 'features/shared/ClickStream';
import React from 'react';
import { BannerWrap, BannerText, BannerHeader, BannerRow } from './styles';
import { BlueButton } from 'features/shared/ui/Button';
import Spacer from 'features/shared/Spacer';

interface Props {
  link: string;
}

const Banner = ({ link }: Props) => (
  <LogClick eventInfo="Клик по блоку на странице вебинаров" eventType="webinars-banner-click">
    <BannerWrap data-qa-id="download_block">
      <BannerText>
        Ученики, чьи педагоги регулярно посещают наши вебинары, больше мотивированы к получению
        <br /> новых знаний — они добиваются лучших результатов в течение учебного года
      </BannerText>
      <Spacer size={12} />
      <BannerRow>
        <div style={{ paddingLeft: 74 }}>
          <BannerHeader>Пригласите учителей на вебинары Учи.ру</BannerHeader>
          <Spacer size={4} />
          <BannerText>
            1. Скачайте расписание в формате PDF
            <br />
            2. Разошлите его по школам
          </BannerText>
        </div>
        <Spacer />
        <LogClick eventInfo="Скачивание приглашения для учителей" eventType="webinars-invite-click">
          <BlueButton
            href={link}
            onClick={(e) => e.stopPropagation()}
            target="_blank"
            rel="noopener"
            style={{ marginBottom: 2 }}
          >
            Скачать расписание
          </BlueButton>
        </LogClick>
      </BannerRow>
    </BannerWrap>
  </LogClick>
);

export default Banner;
